import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
    Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById, putData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { GeneralAddonForm } from "./components/generalAddonForm";
import { useLoading } from "../../../components/Loading";
import { useSnackbar } from "../../../context/popup";

const EditGeneralAddon = () => {

  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const params = useParams();
  const paramId = params.id;
  const [addonData, setAddonData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
    
        if (paramId) {
          setCircleLoading(true);
          try{
            await fetchDataById(`/reference/general/addons/${paramId}`).then((res) => {
            const responseData = res?.data?.addon;
              setAddonData((prevData) => ({
                ...prevData,
                name: responseData?.name,
                description: responseData?.description,
                autoApply: responseData?.autoApply,
                mandatory: responseData?.mandatory,
                productId: responseData?.products?.map((p) => p.id) || [],
                policyTypeId: responseData?.policyTypes?.map((p) => p.id) || [],
                isActive: responseData?.isActive,

                nameStatus: responseData?.name? "success" : "unchecked",
                descriptionStatus: responseData?.description ? "success" : "unchecked",
                productIdStatus: responseData?.products?.length > 0 ? "success" : "unchecked",
                policyTypeIdStatus: responseData?.policyTypes?.length > 0 ? "success" : "unchecked"
              }));
            });
          }
          catch(error){
            console.error("Error fetching data",error)
            showSnackbar(error?.response?.data?.message, "error");
          }
          finally{
            setCircleLoading(false)
          }
        }

      };
  
    fetchData();
  }, [params.id]);


  const handleUpdateAddon = async (addonData) => {

    const payload = {
        name: addonData?.name,
        description: addonData?.description,
        autoApply: addonData?.autoApply,
        mandatory: addonData?.mandatory,
        isActive: addonData?.isActive,
        productIds: addonData?.productId || [],
        policyTypeIds: addonData?.policyTypeId || []
    };
    try {
      const response = await putData(`/reference/general/addons/${paramId}`, payload);
      if(response?.success){
        navigate("/general-master/general-addon");
        showSnackbar(response?.message, "success");
      }else{
        showSnackbar(response?.message || "Error Updating General Addon", "error");
      }
    } catch (error) {
      console.error("Error Updating Addon", error);
      showSnackbar("Error Updating Addon", "error");
    }      
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/general-master/general-addon")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Addon details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Update Addon details here according to their Products and Policy Types.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <GeneralAddonForm onsubmit={handleUpdateAddon} editAddonData={addonData} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default EditGeneralAddon;
